import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=12ac9879&scoped=true&"
var script = {}
import style0 from "./aside.vue?vue&type=style&index=0&id=12ac9879&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ac9879",
  null
  
)

export default component.exports